'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Selectors


// Actions


// Components


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _CSSTransitionGroup = require('react-transition-group/CSSTransitionGroup');

var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

var _lodash = require('lodash');

var _documentModeSelector = require('./documentModeSelector');

var _selectionActions = require('../../element/selection/selectionActions');

var _Document = require('./Document');

var _Document2 = _interopRequireDefault(_Document);

var _MobileBoardHeader = require('./MobileBoardHeader');

var _MobileBoardHeader2 = _interopRequireDefault(_MobileBoardHeader);

var _MobileFloatingTool = require('./MobileFloatingTool');

var _MobileFloatingTool2 = _interopRequireDefault(_MobileFloatingTool);

var _AppHeader = require('../header/AppHeader');

var _AppHeader2 = _interopRequireDefault(_AppHeader);

var _AndroidStopEditingHelper = require('./android/AndroidStopEditingHelper');

var _AndroidStopEditingHelper2 = _interopRequireDefault(_AndroidStopEditingHelper);

require('./MobileWorkspace.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        deselectAll: function deselectAll(event) {
            return dispatch((0, _selectionActions.deselectAllElements)());
        }
    };
};

// Styles


var PAGE_TRANSITION_DUR = 300;
var CURRENT_BOARD_HEADER_HEIGHT = 64;

var MobileWorkspace = (_dec = (0, _reactRedux.connect)(_documentModeSelector.documentSelector, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(MobileWorkspace, _React$Component);

    function MobileWorkspace(props) {
        _classCallCheck(this, MobileWorkspace);

        var _this = _possibleConstructorReturn(this, (MobileWorkspace.__proto__ || Object.getPrototypeOf(MobileWorkspace)).call(this, props));

        _this.onScroll = (0, _lodash.throttle)(function (event) {
            _this.setScrollBodyClass(window.scrollY > CURRENT_BOARD_HEADER_HEIGHT);
        }, 100);

        _this.setScrollBodyClass = function (enable) {
            if (enable === _this.hasBodyClass) return;

            _this.hasBodyClass = enable;

            enable ? document.body.classList.add('mobile-scrolled') : document.body.classList.remove('mobile-scrolled');
        };

        _this.attachScrollListener = function (enable) {
            return window.addEventListener('scroll', _this.onScroll);
        };

        _this.removeScrollListener = function (enable) {
            return window.removeEventListener('scroll', _this.onScroll);
        };

        _this.hasBodyClass = false;

        _this.state = {
            pageTransition: 'slide-left'
        };
        return _this;
    }

    _createClass(MobileWorkspace, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.attachScrollListener();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!nextProps.documentMode) return;
            if (nextProps.currentBoardId === this.props.currentBoardId) return;
            if (nextProps.breadcrumb.path === this.props.breadcrumb.path) return;

            var pageTransition = nextProps.breadcrumb.path.length >= this.props.breadcrumb.path.length ? 'slide-left' : 'slide-right';

            this.setState({ pageTransition: pageTransition });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (prevProps.currentBoardId === this.props.currentBoardId) return;

            // following is for elegent handling of animated iOS listview style navigation

            // if we have changed page, manually add padding top of next board
            // equal to the current scroll position
            var styleStr = 'top: ' + window.scrollY + 'px;';
            if (this.nextBoard) {
                var nextBoardNode = _reactDom2.default.findDOMNode(this.nextBoard);
                nextBoardNode && nextBoardNode.setAttribute('style', styleStr);
            }

            // then after the transition has completed, scroll to top of page
            (0, _lodash.delay)(function () {
                return window.scrollTo(0, 0);
            }, PAGE_TRANSITION_DUR);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.removeScrollListener();
            this.setScrollBodyClass(false);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                currentBoardId = _props.currentBoardId,
                gridSize = _props.gridSize,
                deselectAll = _props.deselectAll;
            var pageTransition = this.state.pageTransition;


            return _react2.default.createElement(
                'div',
                { className: 'DocumentMode' },
                _react2.default.createElement(_AndroidStopEditingHelper2.default, null),
                _react2.default.createElement(_AppHeader2.default, this.props),
                _react2.default.createElement(_MobileFloatingTool2.default, this.props),
                _react2.default.createElement(
                    'div',
                    { className: 'content-wrapper' },
                    _react2.default.createElement(
                        _CSSTransitionGroup2.default,
                        {
                            transitionName: pageTransition,
                            transitionEnterTimeout: PAGE_TRANSITION_DUR,
                            transitionLeaveTimeout: PAGE_TRANSITION_DUR },
                        _react2.default.createElement(
                            'div',
                            {
                                className: 'content',
                                key: currentBoardId, ref: function ref(c) {
                                    _this2.nextBoard = c;
                                },
                                onClick: deselectAll },
                            _react2.default.createElement('div', { className: 'header-spacer' }),
                            _react2.default.createElement(_MobileBoardHeader2.default, this.props),
                            _react2.default.createElement(_Document2.default, _extends({}, this.props, { currentBoardId: currentBoardId, gridSize: gridSize }))
                        )
                    )
                )
            );
        }
    }]);

    return MobileWorkspace;
}(_react2.default.Component)) || _class);


MobileWorkspace.propTypes = {
    currentBoardId: _propTypes2.default.string.isRequired,
    gridSize: _propTypes2.default.number,
    documentMode: _propTypes2.default.bool,
    isEditable: _propTypes2.default.bool,
    elementFilter: _propTypes2.default.object,
    breadcrumb: _propTypes2.default.object,
    deselectAll: _propTypes2.default.func
};

exports.default = MobileWorkspace;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/mobile/MobileWorkspace.js
// module id = 2204
// module chunks = 0